import List from "components/list";
import { useParams } from "react-router-dom";
import { StatusCell } from "@/components/status/cell";
import { DateCell } from "@/components/date/cell";
import { EmployeeUserCell } from "components/cell/employee/cell";
import JobNameCell from "@/components/cells/jobs/name-cell";
import { getdirectusUserFields } from "components/user/config";

export default function ClientSurveys() {

    const { clientId } = useParams();

    const columns = [
        {
            id: "title",
            header: "Title",
            accessorKey: "title",
        },
         {
            id: "project",
            header: "Project",
            accessorKey: "job.project.name",
        },
        {
            id: "job",
            header: "Job",
            accessorKey: "job.name",
            cell: JobNameCell,
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
        {
            id: "date_created",
            header: "Created on",
            accessorKey: "date_created",
            cell: DateCell,
        },
        {
            id: "user_created",
            header: "Created by",
            accessorKey: "user_created",
            cell: EmployeeUserCell,
        },
        {
            id: "date_updated",
            header: "Submitted On",
            accessorKey: "date_updated",
            cell: DateCell,
        },
        {
            id: "user_updated",
            header: "Submitted by",
            accessorKey: "user_updated",
            cell: EmployeeUserCell,
        },
    ];

    const fields = [
        "id",
        "status",
        "title",
        "job.id",
        "job.name",
        "job.project.id",
        "job.project.name",
        "job.project.client.id",
        "date_created",
        "date_updated",
        getdirectusUserFields("user_created"),
        getdirectusUserFields("user_updated"),
    ];

    const filters = {
        job: {
            project: {
                client: {
                    _eq: clientId,
                }
            },
        },
    };

    return (
        <div className="flex-1 w-full">
            <List
                title="Surveys"
                endPoint="surveys"
                storageKey={`survey-${clientId}`}
                showSearch={false}
                filters={filters}
                columns={columns}
                meta={{ fields }}
                href={(item) => `/work/jobs/${item.job.id}/surveys/${item.id}`}
            />
        </div>
    );
}
